module.exports = __webpack_public_path__ + "static/media/file-minus-icon.268470c1.svg";